import { RootState } from "../../../../store";
import { resourceExplorerFilterByKeyAndProviderSelector } from "../resourceExplorerFilterByKeyAndProviderSelector";
import {
  ResourceExplorerFilterItem,
  ProviderType,
} from "../../../../../services/cloudchipr.api";

export const dbSelectedRegionSelector = (
  state: RootState,
  provider: ProviderType,
): ResourceExplorerFilterItem => {
  const filter = resourceExplorerFilterByKeyAndProviderSelector(
    state,
    "region",
    provider,
  );

  return {
    ...filter,
    cloud_provider: provider,
    operator: filter?.operator ?? "in",
    value: filter?.value ?? [],
    key: "region",
  };
};
